// extracted by mini-css-extract-plugin
export default {"iconWrapper":"style_iconWrapper__yZf9j","iconWrapperDark":"style_iconWrapperDark__yCM+v","customCarousel":"style_customCarousel__itMsQ"};